import { apiHelper } from '../utils/apiHelper';

const API_URL = `${process.env.REACT_APP_API_URL}/api/org/faq`;

const headers = {
  "Content-Type": "multipart/form-data",
  "Accept": "application/json"
};

export const fetchFaq = (payload) => apiHelper(API_URL, 'GET', payload);
export const createFaq = (payload) => apiHelper(API_URL, 'POST', payload, headers);
export const fetchFaqDetail = (faqId) => apiHelper(`${API_URL}/${faqId}`, 'GET');
export const modifyFaq = (payload) => apiHelper(`${API_URL}/${payload.get('id')}`, 'POST', payload, headers);
export const deleteFaq = (faqId) => apiHelper(`${API_URL}/${faqId}`, 'DELETE');
export const changeStatus = (faqId) => apiHelper(`${API_URL}/change-status/${faqId}`, 'POST');